





































































import Vue from 'vue';
import i18n from 'vue-i18n';
import { v4 as uuidv4 } from 'uuid';
import CoModal from '@/components/Organisms/co-modal/CoModal.vue';
import CoEditorContent from '@/components/Molecules/co-editor-content/CoEditorContent.vue';
import CoEditor from '@/components/Molecules/co-editor/CoEditor.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoPill from '@/components/Atoms/co-pill/CoPill.vue';

Vue.use(i18n);

export default {
    name: 'CoEditableText',
    components: { CoEditorContent, CoModal, CoEditor, CoButton, CoHeadline, CoText, CoPill },
    props: {
        // Await persistence before treating an edited document as saved.
        saveMethod: {
            type: Function,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        content: {
            type: String,
            default: '',
            required: true,
        },
        editorTitle: {
            type: String,
            default: null,
            required: false,
        },
        editorFullScreen: {
            type: Boolean,
            default: false,
            required: false,
        },
        allowStyling: {
            type: Boolean,
            default: true,
            required: false,
        },
        placeholder: {
            type: String,
            default: '',
            required: false,
        },
    },
    data() {
        return {
            saving: false,
            titleId: `co-editable-text-${uuidv4()}`,
            editedContent: { Html: this.content },
            localContent: null,
        };
    },
    computed: {
        hasChanges() {
            return this.editedContent.Html !== this.localContent;
        },
    },
    watch: {
        content(newContent) {
            this.localContent = newContent;
        },
    },
    mounted() {
        this.localContent = this.content;
    },
    methods: {
        openEditor() {
            if (!this.disabled) this.$refs.textEditModal.show();
        },
        discardChanges() {
            this.$emit('update:discard', this.editedContent);
            this.editedContent = { Html: this.content };
            this.$refs.textEditModal.hide();
        },
        async saveChanges() {
            if (this.saving || !this.hasChanges) return;
            this.saving = true;
            try {
                const savedContent = this.saveMethod
                    ? await this.saveMethod(this.editedContent)
                    : this.editedContent.Html;
                this.localContent = savedContent;
                this.$emit('update:save', this.editedContent);
                this.$refs.textEditModal.hide();
            } catch {
                // The save callback reports the error; preserve the open draft for an unchanged retry.
            } finally {
                this.saving = false;
            }
        },
    },
};
